// @ts-nocheck
// Store Custom Code - Widget Modified to allow custom sizing
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getCssUnitField from "@store/Framework/Common/Fields/Toolkit/cssUnit";
import getSpacingPresetField, { spacingPresetOptions } from "@store/Framework/Common/Fields/Toolkit/spacingPreset";
import { defaultBorderProps } from "@store/Library/Components/Toolkit/Block/defaultProps";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import React, { FC, useMemo } from "react";
import { css, useTheme } from "styled-components";

/* Store Custom Code - Start */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const enum fields {
    presetSpacing = "presetSpacing",
    customSpacing = "customSpacing",
    showHorizontalRule = "showHorizontalRule",
    // Store Custom Code
    spacerHeight = "spacerHeight",
    hasMobileHeight = "hasMobileHeight",
    mobileHeight = "mobileHeight",
}

/* Starter Custom Code - Start */
const presetSpacingField = getSpacingPresetField(fields.presetSpacing, { showCustom: true });
const customSpacingField = getCssUnitField(fields.customSpacing);
/* Starter Custom Code - End */

interface Props extends WidgetProps {
    extendedStyles?: SpacerStyles; // Store Custom Code
    fields: {
        [fields.presetSpacing]: string;
        [fields.customSpacing]: string;
        [fields.showHorizontalRule]: boolean;
        // Store Custom Code
        [fields.spacerHeight]: number;
        [fields.hasMobileHeight]: boolean;
        [fields.mobileHeight]: number;
    };
}

export interface SpacerStyles {
    horizontalRule?: InjectableCss;
    // Store Custom Code
    spacer?: InjectableCss;
}

export const spacerStyles: SpacerStyles = {
    horizontalRule: {
        css: css`
            margin: 0;
            border: 0;
            border-top: ${defaultBorderProps.width} ${defaultBorderProps.type} ${getColor(defaultBorderProps.color)};
        `,
    },
    // Store Custom Code
    spacer: {
        css: css`
            display: block;
            width: 100%;

            &.horizontal-rule {
                border: 0;
                border-top: ${defaultBorderProps.width} ${defaultBorderProps.type} ${getColor(defaultBorderProps.color)};
            }
        `,
    },
};

const styles = spacerStyles; // Store Custom Code

const Spacer: FC<Props> = ({
    fields: {
        presetSpacing,
        customSpacing,
        showHorizontalRule,
        // Store Custom Code
        spacerHeight,
        hasMobileHeight,
        mobileHeight,
    },
}) => {
    /* Store Custom Code - removed starter spacing style */

    /* Store Custom Code - Start */
    const spacerMobileHeight = hasMobileHeight ? mobileHeight : spacerHeight;

    const spacerStyles = {
        css: css`
            ${styles.spacer?.css || ""}

            ${showHorizontalRule
                ? breakpointValues(
                      [pxToRem(spacerMobileHeight), null, null, pxToRem(spacerHeight)],
                      ["margin-top", "margin-bottom"],
                  )
                : breakpointValues([pxToRem(spacerMobileHeight), null, null, pxToRem(spacerHeight)], "height")}
        `,
    };

    return <StyledWrapper {...spacerStyles} className={showHorizontalRule ? "horizontal-rule" : ""}></StyledWrapper>;
    /* Store Custom Code - End */
};

const widgetModule: WidgetModule = {
    component: Spacer,
    definition: {
        group: "Basic",
        displayName: "Spacer",
        icon: "arrows-from-line",
        fieldDefinitions: [
            /* Store Removed - presetSpacingField */
            /* Store Removed - customSpacingField */
            /* Store Custom Code - Start */
            {
                name: fields.spacerHeight,
                displayName: "Height",
                editorTemplate: "IntegerField",
                defaultValue: 10,
                fieldType: "Contextual",
                min: 0,
                tooltip: "Size will render in px",
            },
            {
                name: fields.hasMobileHeight,
                displayName: "Add Mobile Specific Height",
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                defaultValue: false,
                isRequired: true,
                variant: "toggle",
            },
            {
                name: fields.mobileHeight,
                displayName: "Mobile Height",
                editorTemplate: "IntegerField",
                defaultValue: 10,
                fieldType: "Contextual",
                min: 0,
                isVisible: item => item?.fields[fields.hasMobileHeight],
            },
            /* Store Custom Code - End */
            {
                name: fields.showHorizontalRule,
                displayName: "Show Horizontal Rule",
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                defaultValue: false,
            },
        ],
    },
};

export default widgetModule;
